export default __webpack_public_path__ + "static/media/pptx.d50533cf.svg";